import React from 'react'
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../common/components/form/form.module'

export default function NexusNodeTypesBasicInfoComponent({
  handleInnerFormChange, selectedNexusNodes, NexusZoneId,NexusNodeType,GlobalNexusZone
}: any) {
  console.log(NexusZoneId, "NexusZoneId")
  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Name',
                )
              }}
              type="text"
              value={selectedNexusNodes?.Name}
            />
            <InputContainer
              label="Code"
              name="Code"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Code',
                )
              }}
              type="text"
              value={selectedNexusNodes?.Code}
            />
            <InputContainer

              label="NexusZone"
              labelField="Text"
              list={NexusZoneId}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'NexusZoneId'

                );
              }}
              optionName='Choose NexusZone'
              type="select"
              value={selectedNexusNodes?.NexusZoneId}
              valueField="Value"
            />
            <InputContainer
              label="NexusType"
              labelField="Text"
              list={NexusNodeType}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'NodeTypeId'

                );
              }}
              optionName='Choose NodeType'
              type="select"
              value={selectedNexusNodes?.NodeTypeId}
              valueField="Value"
            />
             <InputContainer
              label="GlobalNexusZone"
              labelField="Name"
              list={GlobalNexusZone}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'GlobalNexusZoneId'

                );
              }}
              optionName='Choose GlobalNexusZone'
              type="select"
              value={selectedNexusNodes?.GlobalNexusZoneId}
              valueField="Value"
            />
             <InputContainer
              label="ServicePod"
              labelField="Name"
              list={GlobalNexusZone}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'ServicePodId'

                );
              }}
              optionName='Choose ServicePod'
              type="select"
              value={selectedNexusNodes?.ServicePodId || 0}
              valueField="Value"
            />
            <InputContainer
              label="Description"
              name="Description"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Description',
                )
              }}
              type="text"
              value={selectedNexusNodes?.Description}
            />
          </div>
        }
        expandedPanel="userInfo"
        headerTitle="Basic Info"
      />
    </>
  )
}